/**
 * @author: lv.chen
 * @date: 2025/9/26
 * @desc: User Data Center页面
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl, history } from 'umi';
import { Layout, Tabs } from 'tea-component';
import useActiveId from '@user-center/_hooks/useActiveId';

const { Body, Content } = Layout;

const DEFAULT_TAB = 'quarter-report';

const TABS = [DEFAULT_TAB];

interface IContentManagementCenterProps extends IBaseProps {}

const ContentManagementCenter: React.FC<IContentManagementCenterProps> = (props) => {
  const { style, className, children } = props;

  const { formatMessage } = useIntl();

  const tabs = [
    {
      id: DEFAULT_TAB,
      label: formatMessage({ id: 'dbu_quarter_report_title' }),
    },
  ];

  const [activeId, setActiveId] = useActiveId({ defaultActiveId: DEFAULT_TAB, activeIds: TABS });

  return (
    <Layout style={style} className={classnames('dbu-content-management-center-layout', className)}>
      <Body>
        <Content>
          <Content.Header
            title={formatMessage({ id: 'dbu_user_data_center_title' })}
            subtitle={formatMessage({ id: 'dbu_user_data_center_subtitle' })}
          >
            <Tabs
              className="dbu-content-management-center-tabs"
              tabs={tabs}
              animated={false}
              activeId={activeId}
              onActive={(tab) => {
                const tabId = tab?.id || '';
                setActiveId(tabId);
                history.replace(`/user-center/content-management-center/${tabId}`);
              }}
            />
          </Content.Header>
          <Content.Body full>{children}</Content.Body>
        </Content>
      </Body>
    </Layout>
  );
};

export default ContentManagementCenter;
